import React, { useEffect } from 'react'

export const stateControl = ({
  state,
  stateRound,
  setdealed,
  setplayer,
  setdealPlayer,
  setraiseCards,
  setDealRaiseCards,
  setdealDealer,
  setTurnCard,
  setdealTurn,
  setRiverCard,
  setdealRiver,
  setflipCard,
  setDealerCards,
  setisFold,
  handleShowResult,
  setStartDeal,
}: any) => {
  const handleDeal = () => {
    setStartDeal(true)
    setplayer([stateRound.cards[0], stateRound.cards[1]])
    setdealed(false)
    setTimeout(() => {
      setdealed(true)
      handleShowResult(true)
      setStartDeal(false)
    }, 1500)
    setdealPlayer(true)
    setdealDealer(true)
  }

  const handleRaise = () => {
    setStartDeal(true)
    setraiseCards([
      stateRound.cards[2],
      stateRound.cards[3],
      stateRound.cards[4],
    ])
    setdealed(false)
    setTimeout(() => {
      setdealed(true)
      handleShowResult(true)
      setStartDeal(false)
    }, 1200)
    setDealRaiseCards(true)
  }

  const handleRiver = () => {
    setStartDeal(true)
    setRiverCard(stateRound.cards[6])
    setdealed(false)
    setTimeout(() => {
      setDealerCards([stateRound.cards[7], stateRound.cards[8]])
      setflipCard(true)
      setTimeout(() => {
        setdealed(true)
        handleShowResult(true)
        setStartDeal(false)
      }, 500)
    }, 500)
    setdealRiver(true)
  }

  useEffect(() => {
    handleShowResult(false)
 
    switch (state) {
      case 4: // START => 4
        handleDeal()
        break
      case 6: // LOST => 6
        if (stateRound.cards[7] === 'X0') {
          setisFold(true)
          handleDeal()
        } else {
          handleRiver()
          // setisFold(false)
        }
        break
      case 14: // RAISE => 14
        handleDeal()
        handleRaise()
        break
      case 15: // TURN => 15
        handleDeal()
        handleRaise()
        setTurnCard(stateRound.cards[5])
        setdealed(false)
        setTimeout(() => {
          setdealed(true)
          handleShowResult(true)
        }, 500)
        setdealTurn(true)
        break
      case 3:
      case 5: // WIN => 5
      case 11: // DRAW => 11
        handleRiver()
        break
      default:
        break
    }
  }, [state])
}

// NONE => 0
// START => 4
// WIN => 5
// LOST => 6
// DRAW => 11
// RAISE => 14
// TURN => 15
// RIVER => 16
